import type { CropVarietyConfigurationsByKey } from "../types.js";

export const appleVarietyConfigurations = {
    // Entries use the name growers know; the trade name or cultivar code goes in aliases.
    // Current commercial and commonly planted eating apples.
    "apple.ambrosia": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.aurora-golden-gala": {
        crop: "apple",
        aliases: ["Aurora", "8S6923"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.autumn-glory": {
        crop: "apple",
        aliases: ["Fulford Gold"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.braeburn": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Hillwell", "Mariri Red"],
    },
    "apple.cameo": {
        crop: "apple",
        aliases: ["Caudle"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.cortland": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.cosmic-crisp": {
        crop: "apple",
        aliases: ["WA 38"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.crimson-crisp": {
        crop: "apple",
        aliases: ["Co-op 39"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.cripps-pink": {
        crop: "apple",
        aliases: ["Pink Lady"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Lady in Red", "Rosy Glow", "Ruby Pink"],
    },
    "apple.elstar": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.envy": {
        crop: "apple",
        aliases: ["Scilate"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.empire": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.evercrisp": {
        crop: "apple",
        aliases: ["MAIA 1"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.fuji": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Aztec Fuji", "BC-2", "Kiku 8"],
    },
    "apple.gala": {
        crop: "apple",
        aliases: ["Royal Gala"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Brookfield", "Buckeye Gala", "Galaxy", "Royal Gala", "Ultima Gala"],
    },
    "apple.ginger-gold": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.golden-delicious": {
        crop: "apple",
        aliases: ["Yellow Delicious", "Golden"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Reinders", "Smoothee"],
    },
    "apple.granny-smith": {
        crop: "apple",
        aliases: ["Granny"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.gravenstein": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.honeycrisp": {
        crop: "apple",
        aliases: ["MN 1711", "Honeycrunch"],
        isExample: true,
        customName: false,
        knownClonalSelections: ["Firestorm", "Royal Red Honeycrisp"],
    },
    "apple.idared": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.jazz": {
        crop: "apple",
        aliases: ["Scifresh"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.jonagold": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Jonagored", "Red Jonaprince"],
    },
    "apple.kanzi": {
        crop: "apple",
        aliases: ["Nicoter"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.lady-alice": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.liberty": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.macoun": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.mcintosh": {
        crop: "apple",
        aliases: ["McIntosh Red"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Marshall", "Rogers"],
    },
    "apple.mutsu": {
        crop: "apple",
        aliases: ["Crispin"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.nicola": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.opal": {
        crop: "apple",
        aliases: ["UEB 3264/2"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.pacific-rose": {
        crop: "apple",
        aliases: ["Scired"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.paula-red": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.pinata": {
        crop: "apple",
        aliases: ["Pinova", "Corail"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.rave": {
        crop: "apple",
        aliases: ["MN 55", "First Kiss"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.red-delicious": {
        crop: "apple",
        aliases: ["Delicious", "Starking"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Oregon Spur", "Red Chief", "Scarlet Spur", "Superchief"],
    },
    "apple.rockit": {
        crop: "apple",
        aliases: ["PremA96"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.rubyfrost": {
        crop: "apple",
        aliases: ["NY2"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.salish": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.smitten": {
        crop: "apple",
        aliases: ["PremA17"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.snapdragon": {
        crop: "apple",
        aliases: ["NY1"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.spartan": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.sugarbee": {
        crop: "apple",
        aliases: ["CN-121", "B-51"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.sweetango": {
        crop: "apple",
        aliases: ["Minneiska"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.zestar": {
        crop: "apple",
        aliases: ["Minnewashta"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    // English and British heritage dessert and culinary apples.
    "apple.ashmeads-kernel": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.blenheim-orange": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.bramleys-seedling": {
        crop: "apple",
        aliases: ["Bramley"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.coxs-orange-pippin": {
        crop: "apple",
        aliases: ["Cox"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.egremont-russet": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.ellisons-orange": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.laxtons-superb": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.orleans-reinette": {
        crop: "apple",
        aliases: ["Reinette d’Orléans"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.ribston-pippin": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.worcester-pearmain": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    // Traditional English cider apples, from bittersweet to sharp.
    "apple.brown-snout": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.browns-apple": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.chisel-jersey": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.dabinett": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.foxwhelp": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.harry-masters-jersey": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.kingston-black": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.somerset-redstreak": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.tom-putt": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.tremletts-bitter": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.yarlington-mill": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    // French cider and heritage apples, especially Normandy and Brittany.
    "apple.avrolles": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.bedan": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.binet-rouge": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.binet-violet": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.calville-blanc-dhiver": {
        crop: "apple",
        aliases: ["Calville Blanc"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.court-pendu-plat": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.douce-moen": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.frequin-rouge": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.gros-frequin": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.medaille-dor": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.michelin": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.reine-des-reinettes": {
        crop: "apple",
        aliases: ["King of the Pippins"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    // North American heritage and cider apples commonly sought by cider growers.
    "apple.arkansas-black": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.baldwin": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.esopus-spitzenburg": {
        crop: "apple",
        aliases: ["Spitzenburg"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.golden-russet": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.harrison": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.hewes-virginia-crab": {
        crop: "apple",
        aliases: ["Hewes Crab"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.jonathan": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.newtown-pippin": {
        crop: "apple",
        aliases: ["Albemarle Pippin", "Yellow Newtown"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.northern-spy": {
        crop: "apple",
        aliases: ["Spy"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.rome-beauty": {
        crop: "apple",
        aliases: ["Rome"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.roxbury-russet": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.stayman": {
        crop: "apple",
        aliases: ["Stayman Winesap"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.wickson-crab": {
        crop: "apple",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.winesap": { crop: "apple", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "apple.york-imperial": {
        crop: "apple",
        aliases: ["York"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "apple.custom": { crop: "apple", aliases: [], isExample: false, customName: true, knownClonalSelections: [] },
} as const satisfies CropVarietyConfigurationsByKey;
